import axios from '../utils/request';

// 模块配置
const moduleConfApi = {
  // 获取标签配置列表
  getTagConfigs(params) {
    return axios({
      url: '/tag/conf',
      type: 'get',
      params
    })
  },
  // 获取所有模块
  getModulesAll() {
    return axios({
      url: "/module/conf/all",
      type: "get",
    });
  },
  // 获取模块配置列表
  getModules(params) {
    return axios({
      url: '/module/conf/list',
      type: 'post',
      params
    })
  },
  // 新增模块
  addModule(params) {
    return axios({
      url: '/module/conf/add',
      type: 'post',
      params
    })
  },
  // 修改模块
  editModule(params) {
    return axios({
      url: '/module/conf/edit',
      type: 'post',
      params
    })
  },
  // 删除模块
  deleteModule(params) {
    return axios({
      url: '/module/conf/delete',
      type: 'post',
      params
    })
  },

  // 获取专题列表
  getSections(params) {
    return axios({
      url: '/module/section/list',
      type: 'post',
      params
    })
  },
  // 新增专题
  addSection(params) {
    return axios({
      url: '/module/section/add',
      type: 'post',
      params
    })
  },
  // 修改专题
  editSection(params) {
    return axios({
      url: '/module/section/edit',
      type: 'post',
      params
    })
  },
  // 删除专题
  deleteSection(params) {
    return axios({
      url: '/module/section/delete',
      type: 'post',
      params
    })
  },
  // 查询专题点击量
  queryClicks(params) {
    return axios({
      url: '/module/section/clicks',
      type: 'post',
      params
    })
  },

  // 获取视频列表
  getVideos(params) {
    return axios({
      url: '/module/video/list',
      type: 'post',
      params
    })
  },
  // 新增视频
  addVideo(params) {
    return axios({
      url: '/module/video/add',
      type: 'post',
      params
    })
  },
  // 批量新增视频
  addVideos(params) {
    return axios({
      url: '/module/video/add/batch',
      type: 'post',
      params
    })
  },
  // 修改视频
  editVideo(params) {
    return axios({
      url: '/module/video/edit',
      type: 'post',
      params
    })
  },
  // 删除视频
  deleteVideo(params) {
    return axios({
      url: '/module/video/delete',
      type: 'post',
      params
    })
  },
   // 获取跑马灯内容
   queryMarquee(params) {
    return axios({
      url: '/module/conf/marquee',
      type: 'get',
      params
    })
  },
  // 编辑跑马灯
  modifyMarquee(params) {
    return axios({
      url: '/module/conf/marquee',
      type: 'post',
      params
    })
  },
  // 金刚区
  // 金刚区列表查询
  queryKingKongList(params) {
    return axios({
      url: '/jingang/list',
      type: 'get',
      params
    })
  },
  // 金刚区添加
  addKingKong(params) {
    return axios({
      url: '/jingang/add',
      type: 'post',
      params
    })
  },
  // 金刚区修改
  modifyKingKong(params) {
    return axios({
      url: '/jingang/update',
      type: 'post',
      params
    })
  },
  // 金刚区删除
  delKingKong(params) {
    return axios({
      url: '/jingang/delete',
      type: 'post',
      params
    })
  },
}

export default moduleConfApi;